import {
  FC,
  useState,
  useEffect,
  createContext,
  useContext,
  Dispatch,
  SetStateAction,
} from 'react'
import {LayoutSplashScreen} from '../../../../_metronic/layout/core'
import {AuthModel, UserModel} from './_models'
import * as authHelper from './AuthHelpers'
import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore/lite';

type AuthContextProps = {
  auth: AuthModel | undefined
  saveAuth: (auth: AuthModel | undefined) => void
  currentUser: UserModel | undefined
  setCurrentUser: Dispatch<SetStateAction<UserModel | undefined>>
  logout: () => void
}

const initAuthContextPropsState = {
  auth: authHelper.getAuth(),
  saveAuth: () => {},
  currentUser: undefined,
  setCurrentUser: () => {},
  logout: () => {},
}

const AuthContext = createContext<AuthContextProps>(initAuthContextPropsState)

const firebaseConfig = {
  apiKey: "AIzaSyDnyomA90Kg1yrELokYx02jOHRs_Cm7LGc",
  authDomain: "gj08-6e7ea.firebaseapp.com",
  projectId: "gj08-6e7ea",
  storageBucket: "gj08-6e7ea.appspot.com",
  messagingSenderId: "527457566258",
  appId: "1:527457566258:web:da78475eabd5ae580b062b",
  measurementId: "G-KGVQ6TS2WV"
};

const firebaseApp = initializeApp(firebaseConfig);
const firebaseDB = getFirestore(firebaseApp);
const firebaseAuth = getAuth(firebaseApp);

const useAuth = () => {
  return useContext(AuthContext)
}

const AuthProvider: FC = ({children}) => {
  const [auth, setAuth] = useState<AuthModel | undefined>(authHelper.getAuth())
  const [currentUser, setCurrentUser] = useState<UserModel | undefined>()
  const saveAuth = (auth: AuthModel | undefined) => {
    setAuth(auth)
    if (auth) {
      authHelper.setAuth(auth)
    } else {
      authHelper.removeAuth()
    }
  }

  const logout = () => {
    saveAuth(undefined)
    setCurrentUser(undefined)
    firebaseAuth.signOut()
  }

  return (
    <AuthContext.Provider value={{auth, saveAuth, currentUser, setCurrentUser, logout}}>
      {children}
    </AuthContext.Provider>
  )
}

const AuthInit: FC = ({children}) => {
  const {logout, setCurrentUser} = useAuth()
  const [showSplashScreen, setShowSplashScreen] = useState(true)
  // We should request user by authToken (IN OUR EXAMPLE IT'S API_TOKEN) before rendering the application

  async function getUserRecordFromFirestoreDB(firebaseUser: any) {
    try {

      const q = query(collection(firebaseDB, "students"), where("email", "==", firebaseUser.email));
      const facilitatorCollectionQuery = query(collection(firebaseDB, "facilitators"), where("email", "==", firebaseUser.email));
      let querySnapshot = await getDocs(q);
      // If on student collection value is emmpty check on facilitator collection
      if(querySnapshot.empty) {
        querySnapshot = await getDocs(facilitatorCollectionQuery);
      }
      querySnapshot.forEach((user) => {

        console.log("firebaseUser.email: ", firebaseUser.email);
        console.log("user.data().email: ", user.data().email);

        if (firebaseUser.email === user.data().email) {
          console.log("user from DB: ", user.data());

          if (user.data().isfacilitator === "false") {
            // load student model
            const userModel: UserModel = {
              id: firebaseUser.uid,
              username: user.data().email,
              email: user.data().email,
              password: firebaseUser.password,
              first_name: user.data().firstname,
              last_name: user.data().lastname,
              fullname: user.data().firstname + " " + user.data().lastname,
              occupation: "student",
              phone: user.data().phonenumber,
              address: user.data().location,
              // student fields
              class: user.data().class,
              country: user.data().country,
              dateOfBirth: user.data().dateofbirth,
              isFacilitator: user.data().isfacilitator,
              school: user.data().school,
              state: user.data().state,
              uniqueIdentificationNumber: user.data().uniqueidentificationnumber,
            };

            setCurrentUser(userModel);
            console.log("student Model: ", userModel);
          }
          else {
            // load facilitator model
            const userModel: UserModel = {
              id: firebaseUser.uid,
              username: user.data().email,
              email: user.data().email,
              password: firebaseUser.password,
              first_name: user.data().firstname,
              last_name: user.data().lastname,
              fullname: user.data().firstname + " " + user.data().lastname,
              occupation: "facilitator",
              phone: user.data().phonenumber,
              address: user.data().location,
              // facilitator fields
              dateOfBirth: user.data().dateofbirth,
              phoneNumber: user.data().phonenumber,
              grade: user.data().grade,
              location: user.data().location
            };

            setCurrentUser(userModel);
            console.log("facilitatorModel: ", userModel);
          }
        }

      });
    }
    catch (error) {
      console.log("error in auth: ", error);
      logout()
    }
    finally {
      setShowSplashScreen(false)
    }

  }

  useEffect(() => {
    onAuthStateChanged(firebaseAuth, (firebaseUser) => {
      if (firebaseUser) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/firebase.User
        // const uid = firebaseUser.uid;
        console.log("already signed in");
        console.log("firebaseUser: ", firebaseUser);
        
        getUserRecordFromFirestoreDB(firebaseUser)
        // ...
      } else {
        // User is signed out
        // ...
        console.log("signed out");
        logout()
        setShowSplashScreen(false)
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return showSplashScreen ? <LayoutSplashScreen /> : <>{children}</>
}

export {AuthProvider, AuthInit, useAuth}
